import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import { ResponsiveEmbed } from "react-bootstrap";
import ObjectiveCompetencyServices from "./ObjectiveCompetency.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetObjectiveCompetency = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: true,
    });
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY,
      payload: {
        objectiveCompetencies: [],
        objectiveCompetenciesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: false,
    });
  }
};

export const getObjectiveCompetency = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: true,
    });
    const resp = await ObjectiveCompetencyServices.getObjectiveCompetency(filters);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY,
      payload: {
        objectiveCompetencies: resp.data.data || [],
        objectiveCompetenciesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: false,
    });
  }
};

export const getObjectiveCompetencyById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_BY_ID,
      payload: true,
    });
    const resp = await ObjectiveCompetencyServices.getObjectiveCompetencyById(id);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_BY_ID,
      payload: false,
    });
  }
};

export const saveObjectiveCompetency = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY,
      payload: true,
    });
    const resp = await ObjectiveCompetencyServices.saveObjectiveCompetency(data);
    const { objectiveCompetencies, objectiveCompetenciesLength } = getState().objectiveCompetency;
    const _objectiveCompetencies = [...objectiveCompetencies, resp.data.competencia_principal];
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY,
      payload: {
        objectiveCompetencies: _objectiveCompetencies,
        objectiveCompetenciesLength: objectiveCompetenciesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY,
      payload: false,
    });
  }
};

export const editObjectiveCompetency = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY,
      payload: true,
    });
    const resp = await ObjectiveCompetencyServices.editObjectiveCompetency(id, data);
    const { objectiveCompetencies, objectiveCompetenciesLength } = getState().objectiveCompetency;
    objectiveCompetencies[index] = resp.data.competencia_principal;
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY,
      payload: {
        objectiveCompetencies: objectiveCompetencies,
        objectiveCompetenciesLength: objectiveCompetenciesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY,
      payload: false,
    });
  }
};

export const deleteObjectiveCompetency = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: true,
    });
    await ObjectiveCompetencyServices.deleteObjectiveCompetency(id);
    const { objectiveCompetencies, objectiveCompetenciesLength } = getState().objectiveCompetency;
    objectiveCompetencies.splice(index, 1);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY,
      payload: {
        objectiveCompetencies: objectiveCompetencies,
        objectiveCompetenciesLength: objectiveCompetenciesLength - 1,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY,
      payload: false,
    });
  }
};
